import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'b', 'i', 'u',
  'ul', 'ol', 'li',
  'h2', 'h3', 'h4',
  'blockquote',
  'a', 'span',
  // Tables (used in article prose content)
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  // Images in articles (src validated server-side via storage bucket policy)
  'img',
  // Horizontal rule
  'hr',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'src', 'alt', 'loading', 'decoding', 'colspan', 'rowspan'];

// Force tous les liens ouverts dans un nouvel onglet à avoir rel="noopener noreferrer"
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    if (node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  }
});

export function sanitizeHtml(html: string): string {
  if (!html || typeof html !== 'string') return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'style'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onkeydown', 'onkeyup', 'onkeypress'],
    FORCE_BODY: false,
  });
}
